/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';

import { registerLicense } from '@syncfusion/ej2-base';
import { environment } from '@environment/environment';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Registering Syncfusion license key
registerLicense(environment.syncFusionKey);
bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
